export const ProjectEventTypeDetailsMutations = {
  SetProjectEventType: 'setProjectEventType',
  SetProjectEventTypeDetailsLoading: 'setProjectEventTypeDetailsLoading',
  SetProjectEventTypeAttachmentsLoading: 'setProjectEventTypeAttachmentsLoading',
  SetProjectTools: 'setProjectTools',
  SetIsSavingProjectEventType: 'setIsSavingProjectEventType',
  SortProjectEventTypeTechRates: 'sortProjectEventTypeTechRates',
  SortProjectEventTypeTools: 'sortProjectEventTypeTools',
  SortProjectEventTypeSpecialRequirements: 'sortProjectEventTypeSpecialRequirements',
  SetProjectEventTypeTechRatesSortOrder: 'setProjectEventTypeTechRatesSortOrder',
  SetProjectEventTypeToolsSortOrder: 'setProjectEventTypeToolsSortOrder',
  SetProjectEventTypeSpecialRequirementsSortOrder:
    'setProjectEventTypeSpecialRequirementsSortOrder',
  DeleteProjectEventTypeValidationErrorKeySuccess:
    'deleteProjectEventTypeValidationErrorKeySuccess',
  DeleteProjectEventTypeTechRatesValidationErrorKeySuccess:
    'deleteProjectEventTypeTechRatesValidationErrorKeySuccess',
  DeleteProjectEventTypeBillingValidationErrorKeySuccess:
    'deleteProjectEventTypeBillingValidationErrorKeySuccess',
  DeleteProjectEventTypeToolsValidationErrorKeySuccess:
    'deleteProjectEventTypeToolsValidationErrorKeySuccess',
  DeleteProjectEventTypeSpecialRequirementsValidationErrorKeySuccess:
    'deleteProjectEventTypeSpecialRequirementsValidationErrorKeySuccess',
  FetchProjectEventTypeAttachmentsSuccess: 'fetchProjectEventTypeAttachmentsSuccess',
  SetProjectEventTypeValidationErrorsSuccess: 'setProjectEventTypeValidationErrorsSuccess',
  SetProjectEventTypeTechRatesValidationErrorsSuccess:
    'setProjectEventTypeTechRatesValidationErrorsSuccess',
  SetProjectEventTypeBillingValidationErrorsSuccess:
    'setProjectEventTypeBillingValidationErrorsSuccess',
  SetProjectEventTypeToolsValidationErrorsSuccess:
    'setProjectEventTypeToolsValidationErrorsSuccess',
  SetProjectEventTypeSpecialRequirementsValidationErrorsSuccess:
    'setProjectEventTypeSpecialRequirementsValidationErrorsSuccess'
};

export const ProjectEventTypeDetailsActions = {
  FetchProjectEventType: 'fetchProjectEventType',
  FetchProjectEventTypeAttachments: 'fetchProjectEventTypeAttachments',
  FetchProjectTools: 'fetchProjectTools',
  SaveProjectEventType: 'saveProjectEventType',
  SetProjectEventTypeTechRatesSortOrder: 'setProjectEventTypeTechRatesSortOrder',
  SetProjectEventTypeToolsSortOrder: 'setProjectEventTypeToolsSortOrder',
  SetProjectEventTypeSpecialRequirementsSortOrder:
    'setProjectEventTypeSpecialRequirementsSortOrder',
  DeleteProjectEventTypeValidationErrorKey: 'deleteProjectEventTypeValidationErrorKey',
  SetProjectEventTypeValidationErrors: 'setProjectEventTypeValidationErrors',
  SetProjectEventTypeTechRatesValidationErrors: 'setProjectEventTypeTechRatesValidationErrors',
  SetProjectEventTypeBillingValidationErrors: 'setProjectEventTypeBillingValidationErrors',
  SetProjectEventTypeToolsValidationErrors: 'setProjectEventTypeToolsValidationErrors',
  SetProjectEventTypeSpecialRequirementsValidationErrors:
    'setProjectEventTypeSpecialRequirementsValidationErrors'
};

export const ProjectEventTypeDetailsGetters = {
  ProjectEventType: 'ProjectEventType',
  ProjectEventTypeAttachments: 'ProjectEventTypeAttachments',
  ProjectTools: 'ProjectTools',
  IsProjectEventTypeDetailsLoading: 'IsProjectEventTypeDetailsLoading',
  IsProjectEventTypeAttachmentsLoading: 'IsProjectEventTypeAttachmentsLoading',
  IsSavingProjectEventType: 'IsSavingProjectEventType',
  ProjectEventTypeTechRatesSortOrder: 'ProjectEventTypeTechRatesSortOrder',
  ProjectEventTypeToolsSortOrder: 'ProjectEventTypeToolsSortOrder',
  ProjectEventTypeSpecialRequirementsSortOrder: 'ProjectEventTypeSpecialRequirementsSortOrder',
  ProjectEventTypeValidationErrors: 'ProjectEventTypeValidationErrors',
  ProjectEventTypeTechRatesValidationErrors: 'ProjectEventTypeTechRatesValidationErrors',
  ProjectEventTypeBillingValidationErrors: 'ProjectEventTypeBillingValidationErrors',
  ProjectEventTypeToolsValidationErrors: 'ProjectEventTypeToolsValidationErrors',
  ProjectEventTypeSpecialRequirementsValidationErrors:
    'ProjectEventTypeSpecialRequirementsValidationErrors'
};
